import(/* webpackMode: "eager" */ "/opt/render/project/src/src/app/wallet/page.js");
